import React from 'react'
import { useSwipeable, Swipeable } from 'react-swipeable'
import iconPaste from '../svgs/icons'
import {ReactComponent as IconClose} from '../svgs/close.svg';
import '../../node_modules/react-vis/dist/style.css';
import {DiscreteColorLegend, VerticalBarSeries, FlexibleXYPlot, Highlight, AreaSeries, Crosshair, VerticalGridLines, HorizontalGridLines, XAxis, YAxis, XYPlot, LineSeries} from 'react-vis';
import localization from '../lib/localization/localization'
import api from '../api/api'
import { parseJsonSafely } from '../lib/exchange/parser';

export default function ElementAdditionalPage({element_id, config, chart_data, params, ui_language, newColor, newColorUp, newBright, newBrightUp, newTargetPos, newTargetPosUp, newSaturation, newSaturationUp, newSwState, clickPlus, clickMinus, toNormalState, toChartState, clickMode}){    
    
    let element_name 
    let element_type
    let element_room_name
    let ui_element_svg_id
    let rooms = config.ui_rooms
    let start_color = 0
    let start_bright = 0
    let start_curr_pos = 0
    let start_target_pos = 0
    let start_saturation = 0
    let start_state = 0
    let status_text = 0
    let start_curr_temp = 0
    let start_comf_temp = 0
    let start_mode = 0
    let modes = []
    let modes_line1 = ''
    let thermo_units
    let element_params
    let ui_element_add_data
    let iconSvg
    let css_var = document.querySelector('body')
    let is_chart = false
    let params_history = true
    let param_id
    let element_add_page_content = 'INIT CONTENT'
    let first_init = true
    let chart_data_1 = null
    let chart_data_2 = null
    let chart_data_3 = null
    let chart_data_4 = null
    let chart_data_5 = null


    const data = [
        [
        {x: 0, y: 8},
        {x: 1, y: 5},
        {x: 2, y: 4},
        {x: 3, y: 9},
        {x: 4, y: 1},
        {x: 5, y: 7},
        {x: 6, y: 6},
        {x: 7, y: 3},
        {x: 8, y: 2},
        {x: 9, y: 0}
      ],
      [
        {x: 0, y: 7},
        {x: 1, y: 2},
        {x: 2, y: 5},
        {x: 3, y: 19},
        {x: 4, y: 11},
        {x: 5, y: 5},
        {x: 6, y: 0},
        {x: 7, y: -3},
        {x: 8, y: 8},
        {x: 9, y: 1}
      ]
    ];

    const switch_data_test = [
        {x: 1611682249000, y: 0},
        {x: 1611682949000, y: 1},
        {x: 1611693049000, y: 0},
        {x: 1611693149000, y: 1},
        {x: 1613151469000, y: 0},
        {x: 1614693249000, y: 1},
        {x: 1614720269000, y: 0},
        {x: 1614820269000, y: 1},
        {x: 1615829869000, y: 0},
        {x: 1615929869000, y: 1},
        {x: 1616829869000, y: 0},
        {x: 1617693049000, y: 1},
        {x: 1618008269000, y: 0},
        {x: 1618508269000, y: 1},
        {x: 1621107469000, y: 0},
        {x: 1622107469000, y: 1},
    ]

    const dimmer_data_test = [
        {x: 1611682249000, y: 0},
        {x: 1611682949000, y: 100},
        {x: 1611693049000, y: 56},
        {x: 1611693149000, y: 0},
        {x: 1613151469000, y: 10},
        {x: 1614693249000, y: 23},
        {x: 1614720269000, y: 0},
        {x: 1614820269000, y: 100},
        {x: 1615829869000, y: 0},
        {x: 1615929869000, y: 100},
        {x: 1616829869000, y: 56},
        {x: 1617693049000, y: 32},
        {x: 1618008269000, y: 0},
        {x: 1618508269000, y: 5},
        {x: 1621107469000, y: 78},
        {x: 1622107469000, y: 0},
    ]

    const status_data_test = [
        {x: 1611682249000, y: 25},
        {x: 1611682949000, y: 23},
        {x: 1611693049000, y: 22},
        {x: 1611693149000, y: 19},
        {x: 1613151469000, y: 20},
        {x: 1614693249000, y: 18},
        {x: 1614720269000, y: 20},
        {x: 1614820269000, y: 22},
        {x: 1615829869000, y: 20},
        {x: 1615929869000, y: 25},
        {x: 1616829869000, y: 26},
        {x: 1617693049000, y: 22},
        {x: 1618008269000, y: 20},
        {x: 1618508269000, y: 15},
        {x: 1621107469000, y: 18},
        {x: 1622107469000, y: 20},
    ]

    const r_data_test = [
        {x: 1611682249000, y: 0},
        {x: 1611682949000, y: 100},
        {x: 1611693049000, y: 22},
        {x: 1611793149000, y: 45},
        {x: 1613151469000, y: 20},
        {x: 1614693249000, y: 53},
        {x: 1614720269000, y: 0},
        {x: 1614820269000, y: 12},
        {x: 1615829869000, y: 0},
        {x: 1615929869000, y: 15},
        {x: 1616829869000, y: 26},
        {x: 1617693049000, y: 82},
        {x: 1618008269000, y: 0},
        {x: 1619508269000, y: 15},
        {x: 1621107469000, y: 81},
        {x: 1622107469000, y: 0},
    ]
    const g_data_test = [
        {x: 1611682249000, y: 25},
        {x: 1611682949000, y: 13},
        {x: 1611693049000, y: 92},
        {x: 1611693149000, y: 1},
        {x: 1613151469000, y: 0},
        {x: 1614693249000, y: 16},
        {x: 1614720269000, y: 50},
        {x: 1614820269000, y: 92},
        {x: 1615829869000, y: 0},
        {x: 1615929869000, y: 5},
        {x: 1616829869000, y: 26},
        {x: 1617693049000, y: 2},
        {x: 1618008269000, y: 60},
        {x: 1618558269000, y: 75},
        {x: 1621107469000, y: 8},
        {x: 1622107469000, y: 20},
    ]

    const b_data_test = [
        {x: 1611682249000, y: 75},
        {x: 1611685949000, y: 33},
        {x: 1611693049000, y: 2},
        {x: 1611693149000, y: 69},
        {x: 1613151469000, y: 80},
        {x: 1614693249000, y: 18},
        {x: 1614720269000, y: 10},
        {x: 1614850269000, y: 62},
        {x: 1615829869000, y: 50},
        {x: 1615929869000, y: 65},
        {x: 1616829869000, y: 96},
        {x: 1617693049000, y: 2},
        {x: 1618008269000, y: 7},
        {x: 1618508269000, y: 0},
        {x: 1621107469000, y: 58},
        {x: 1622107469000, y: 90},
    ]

    const wc_hue_data_test = [
        {x: 1611682249000, y: 75},
        {x: 1611685949000, y: 33},
        {x: 1611693049000, y: 2},
        {x: 1611693149000, y: 69},
        {x: 1613151469000, y: 80},
        {x: 1614693249000, y: 18},
        {x: 1614720269000, y: 10},
        {x: 1614850269000, y: 62},
        {x: 1615829869000, y: 50},
        {x: 1615929869000, y: 65},
        {x: 1616829869000, y: 96},
        {x: 1617693049000, y: 2},
        {x: 1618008269000, y: 7},
        {x: 1618508269000, y: 0},
        {x: 1621107469000, y: 58},
        {x: 1622107469000, y: 90},
    ]

    const curr_temp_data_test = [
        {x: 1611682249000, y: 25},
        {x: 1611685949000, y: 23},
        {x: 1611693049000, y: 22},
        {x: 1611693149000, y: 19},
        {x: 1613151469000, y: 20},
        {x: 1614693249000, y: 18},
        {x: 1614720269000, y: 20},
        {x: 1614850269000, y: 22},
        {x: 1615829869000, y: 20},
        {x: 1615929869000, y: 25},
        {x: 1616829869000, y: 26},
        {x: 1617693049000, y: 22},
        {x: 1618008269000, y: 27},
        {x: 1618508269000, y: 30},
        {x: 1621107469000, y: 28},
        {x: 1622107469000, y: 20},
    ]

    const comf_temp_data_test = [
        {x: 1611682249000, y: 15},
        {x: 1611685949000, y: 18},
        {x: 1611693049000, y: 22},
        {x: 1611693149000, y: 16},
        {x: 1613151469000, y: 18},
        {x: 1614693249000, y: 18},
        {x: 1614720269000, y: 19},
        {x: 1614850269000, y: 22},
        {x: 1615829869000, y: 22},
        {x: 1615929869000, y: 24},
        {x: 1616829869000, y: 23},
        {x: 1617693049000, y: 22},
        {x: 1618008269000, y: 27},
        {x: 1618508269000, y: 20},
        {x: 1621107469000, y: 20},
        {x: 1622107469000, y: 23},
    ]

    const mode_data_test = [
        {x: 1611682249000, y: 0},
        {x: 1611685949000, y: 1},
        {x: 1611693049000, y: 0},
        {x: 1611693149000, y: 1},
        {x: 1613151469000, y: 1},
        {x: 1614693249000, y: 1},
        {x: 1614720269000, y: 0},
        {x: 1614850269000, y: 1},
        {x: 1615829869000, y: 1},
        {x: 1615929869000, y: 0},
        {x: 1616829869000, y: 0},
        {x: 1617693049000, y: 1},
        {x: 1618008269000, y: 1},
        {x: 1618508269000, y: 0},
        {x: 1621107469000, y: 1},
        {x: 1622107469000, y: 0},
    ]

    function toDiscreteDataUpdater(array){
        if ( array && (array.length > 0)) {
            let new_array = []
            let new_i = 1;
            new_array[0] = array[0]
            for (let i = 1; i < array.length; i++) {
                let y = array[i-1].y;
                if (array[i].y != y) {
                    new_array[new_i] = {x: (array[i].x - 100), y: array[i-1].y}
                    new_i++;
                }
                new_array[new_i] = {x: (array[i].x), y: array[i].y}
                new_i++;
            }
            let timeInMs = Date.now();
            new_array[new_i] = {x: timeInMs, y: new_array[new_i-1].y}
            return new_array;
        }
    }

    function scaleDataUpdater(array, scale){
        if (array.length > 0) {
            for (let i = 0; i < array.length; i++) {
                if (array[i].y > 1) array[i].y = scale
                else array[i].y = 0
            }
            return array;
        }
    }

    function wcHueDataUpdater(array){
        if ((array.length > 0)) {
            let wc = {warm: [], cold: []}
            for (let i = 0; i < array.length; i++) {
                wc.warm[i] = array[i]
                wc.cold[i] = {x: array[i].x, y: (100 - array[i].y)}
            }
            return wc;
        }
    }
    
    function addCurrentTimeDataUpdater(array){
        if ((array) && (array.length > 0)) {
            let timeInMs = Date.now();
            array[array.length] = {x: timeInMs, y: array[array.length-1].y}
            return array;
        }
    }
      
    config.ui_items.map(item => {
        if (item.ui_item_id === element_id) {
            element_name = item.display_name
            element_type = item.ui_item_type
            element_params = item.params
            ui_element_svg_id = item.ui_item_icon_id
            ui_element_add_data = JSON.parse(item.add_data)
            rooms.map(room => {
                if (item.ui_room_id === room.ui_room_id) element_room_name = room.ui_room_name
            })
        }
    }
    )

    const [crosshairValues, setCrosshairValues] = React.useState([])
    const [lastDrawLocation, setLastDrawLocation] = React.useState(null)

    switch (element_type) {
        case 'switch':    
            if ((chart_data) && (chart_data.hasOwnProperty('state'))){
                chart_data_1 = <AreaSeries opacity={1} fill="var(--add_color)" stroke="rgba(0,0,0,0)" data={toDiscreteDataUpdater(chart_data.state)} animation={2}/>
            }
            break;

        case 'rgb':
        case 'rgbw':

            if ((chart_data) && (chart_data.hasOwnProperty('r'))){            
                chart_data_1 = <LineSeries opacity={0.73} stroke="#f00" data={toDiscreteDataUpdater(chart_data.r)} animation={2}/>
                chart_data_2 = <LineSeries opacity={0.73} stroke="#0a0" data={toDiscreteDataUpdater(chart_data.g)} animation={2}/>
                chart_data_3 = <LineSeries opacity={0.73} stroke="#00f" data={toDiscreteDataUpdater(chart_data.b)} animation={2}/>
                chart_data_4 = <AreaSeries opacity={0.35} fill="var(--text_color)" stroke="rgba(0,0,0,0)" data={toDiscreteDataUpdater(chart_data.bright)} animation={2}/>
                chart_data_5 = <DiscreteColorLegend
                colors={[
                    '#f00',
                    '#0a0',
                    '#00f',
                    'var(--text_color)'               
                ]}
                items={[
                    localization.localize(ui_language).red_component,
                    localization.localize(ui_language).green_component,
                    localization.localize(ui_language).blue_component,
                    localization.localize(ui_language).brightness
                ]}
                orientation="vertical"
                />
            }
            
            break;

        case 'warm_cold':
            if ((chart_data) && (chart_data.hasOwnProperty('hue') && Array.isArray(chart_data.hue))){
                let wc_hue = wcHueDataUpdater(chart_data.hue)
                chart_data_1 = <LineSeries opacity={0.73} stroke="#ffe91e" data={toDiscreteDataUpdater(wc_hue.warm)} animation={2}/>
                chart_data_2 = <LineSeries opacity={0.73} stroke="#1eadff" data={toDiscreteDataUpdater(wc_hue.cold)} animation={2}/>
                chart_data_4 = <AreaSeries opacity={0.55} fill="var(--text_color)" stroke="rgba(0,0,0,0)" data={toDiscreteDataUpdater(chart_data.bright)} animation={2}/>
                chart_data_5 = <DiscreteColorLegend
                colors={[
                  '#ffe91e',
                  '#1eadff',
                  'var(--text_color)'               
                ]}
                items={[
                    localization.localize(ui_language).warm_component,
                    localization.localize(ui_language).cold_component,
                    localization.localize(ui_language).brightness
                ]}
                orientation="vertical"
              />
            }
            
            break;
    
        case 'dimmer':  
            if ((chart_data) && (chart_data.hasOwnProperty('bright'))){
                chart_data_1 = <AreaSeries opacity={1} fill="var(--add_color)" stroke="rgba(0,0,0,0)" data={toDiscreteDataUpdater(chart_data.bright)} animation={2}/>
            }
            break;

        case 'status':
            if ((chart_data) && (chart_data.hasOwnProperty('text'))){
                //console.log("element_type", element_type)
                //console.log("chart_data:", chart_data);
                let status_type = "text";
                if ((chart_data.hasOwnProperty('add_data') && (chart_data.add_data))){
                    status_type = parseJsonSafely(chart_data.add_data).type
                }
                //console.log("status_type",status_type)
                chart_data_1 = <LineSeries opacity={1} stroke="var(--add_color)" data={addCurrentTimeDataUpdater(toDiscreteDataUpdater(chart_data.text))} animation={2}/>
                switch (status_type) {
                    case "icon_activity":
                        //console.log("icon_activity")
                        chart_data_4 = <DiscreteColorLegend
                        colors={['var(--add_color)']}
                        items={[localization.localize(ui_language).icon_activity_text]}
                        orientation="vertical"/>
                        break;
                    case "icon_status_color":
                        //console.log("icon_status_color")
                        chart_data_4 = <DiscreteColorLegend
                        colors={['var(--add_color)']}
                        items={[localization.localize(ui_language).icon_status_color_text]}
                        orientation="vertical"/>
                        break;
                    default:
                        break;
                }
            }
            break;

        case 'thermostat':
            if ((chart_data) && (chart_data.hasOwnProperty('curr_temp'))){
                chart_data_1 = <AreaSeries opacity={1} fill="var(--add_color)" stroke="rgba(0,0,0,0)" data={addCurrentTimeDataUpdater(chart_data.curr_temp)} animation={2}/>
                chart_data_2 = <LineSeries opacity={1} stroke="var(--text_color)" data={addCurrentTimeDataUpdater(toDiscreteDataUpdater(chart_data.comf_temp))} animation={2}/>
                chart_data_3 = <AreaSeries opacity={1} fill="var(--text_secondary_color)" stroke="rgba(0,0,0,0)" data={toDiscreteDataUpdater(scaleDataUpdater(chart_data.mode, 10))} animation={2}/>
                chart_data_4 = <DiscreteColorLegend
                colors={[
                    'var(--add_color)',
                    'var(--text_color)',
                    'var(--text_secondary_color)'                  
                ]}
                items={[
                    localization.localize(ui_language).current_temperature,
                    localization.localize(ui_language).comfort_temperature,
                    localization.localize(ui_language).thermostat_mode
                ]}
                orientation="vertical"
                />
            }
        break;

        case 'curtains':
            if ((chart_data) && (chart_data.hasOwnProperty('curr_pos'))){
                chart_data_1 = <AreaSeries opacity={1} fill="var(--add_color)" stroke="rgba(0,0,0,0)" data={addCurrentTimeDataUpdater(toDiscreteDataUpdater(chart_data.curr_pos))} animation={2}/>
                chart_data_2 = <LineSeries opacity={1} stroke="var(--text_color)" data={addCurrentTimeDataUpdater(toDiscreteDataUpdater(chart_data.target_pos))} animation={2}/>
                chart_data_4 = <DiscreteColorLegend
                colors={[
                    'var(--add_color)',
                    'var(--text_color)'                  
                ]}
                items={[
                    localization.localize(ui_language).current_position,
                    localization.localize(ui_language).target_position
                ]}
                orientation="vertical"
                />
            }
        break;
    }


    if (params_history) {
        element_add_page_content = 
        <FlexibleXYPlot  onMouseLeave={() => {setCrosshairValues([])}}
        xDomain={
            lastDrawLocation && [
            lastDrawLocation.left,
            lastDrawLocation.right
            ]
        }
        yDomain={
            lastDrawLocation && [
            lastDrawLocation.bottom,
            lastDrawLocation.top
            ]
        }
        animation>
        
        {chart_data_1}
        {chart_data_2}
        {chart_data_3}
        {chart_data_4}
        {chart_data_5}

        <XAxis style={{fill: 'var(--text_color)'}} tickFormat={function tickFormat(d){return new Date(d).toLocaleString('en-GB')}} tickTotal={4} tickLabelAngle={-12}/>
        <YAxis style={{fill: 'var(--text_color)'}} />
        <Crosshair values={crosshairValues}/>

        <VerticalGridLines opacity={0.25}/>
        <Highlight
        onBrushEnd={area => setLastDrawLocation(area)}
        onDrag={area => {
            setLastDrawLocation({
                bottom: lastDrawLocation.bottom + (area.top - area.bottom),
                left: lastDrawLocation.left - (area.right - area.left),
                right: lastDrawLocation.right - (area.right - area.left),
                top: lastDrawLocation.top + (area.top - area.bottom)
            });
        }}
        />
        </FlexibleXYPlot>
    }
        
    

    return(
        <div>
            <div className="elementPageEmpty" onClick={() => toNormalState()}></div>
            <div className="elementAddPage">
                <div className="close_elementPage" onClick={() => toNormalState()}><IconClose /></div>
                <div className="content-top"> {element_room_name} </div>
                <div className="elementChartContent">{element_add_page_content}</div>
                <div className="all_chart_button" onClick={() => toChartState(element_id, 31536000000)}> {localization.localize(ui_language).all_chart} </div>
                <div className="content-bottom"> {element_name} </div>
            </div>
        </div>
    )

}